var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"rich-text"},[_c('RichTextRenderer',{attrs:{"document":_vm.data,"nodeRenderers":_vm.rendererNodes(),"markRenderers":_vm.rendererMarks()}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }